import { Controller } from "@hotwired/stimulus"
import TermsOfServiceModal from "../modals/terms_of_service_modal"
import CompleteNameModal from "../modals/complete_name_modal"

export default class extends Controller {
  static values = {
    tosAccepted: Boolean,
    tosUpdateUrl: String,
    nameCompleted: Boolean,
    nameUpdateUrl: String
  }

  async connect() {
    await this.showTermsOfServiceIfNeeded()
    await this.showCompleteNameIfNeeded()
  }

  async showTermsOfServiceIfNeeded() {
    if (this.tosAcceptedValue) return

    const modal = new TermsOfServiceModal(this.tosUpdateUrlValue)
    await modal.show()
  }

  async showCompleteNameIfNeeded() {
    if (this.nameCompletedValue) return

    const modal = new CompleteNameModal(this.nameUpdateUrlValue)
    await modal.show()
  }
}
